export enum RaffleStatusEnum {
  ACTIVE = "a", // Em Execução
  INACTIVE = "i", // Inativa
  CREATING = "c", // Precisa subir a premiação
  PENDING = "p", // Precisa efetuar o pagamento
  WAITING = "w", // Aguardando: Já pago, só precisa de ativação manual do Usuário
  QUEUE = "q", // Na Fila para Auto-Ativação (quando utiliza o mesmo slug)
  FINISHED = "f", // Finalizada
  EXCLUDED = "x", // Excluída
}

export enum RaffleTypeEnum {
  DEFAULT_NUMBER = "default_number",
  DEFAULT_WORD = "default_word",
}

export enum RaffleCategoryStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  EXCLUDED = "x",
}

export enum RaffleDrawTypeEnum {
  FEDERAL_LOTTERY = 'fl', // Federal Lottery
  RANDOM_NUMBER = 'rn', // Random Numbers (on sold tickets)
}

export type RaffleDrawTypeTypes = `${RaffleDrawTypeEnum}`;